<div class="row g-3">
    <div class="col-3">
        <div class="card">
            <div class="card-body">
                <form [formGroup]="form" (ngSubmit)="search()">
                    <a class="btn btn-primary float-end" routerLink="/placements/create" i18n>Create</a>
                    <h3 i18n>Product placements</h3>

                    <a routerLink="/placements">Recently viewed</a>
                    <hr>
                    <div class="row g-3">
                        <div class="col-12">
                            <label for="organization" class="form-label" i18n>Country</label>
                            <select id="organization" class="form-select" formControlName="organization">
                                <option ngValue="all" i18n>All</option>
                                <option *ngFor="let organization of organizations" [ngValue]="organization.id">{{
                                    organization.country }}</option>
                            </select>
                        </div>
                        <div class="col-12">
                            <label for="assignment" class="form-label" i18n>Service category</label>
                            <select id="assignment" class="form-select" formControlName="assignment">
                                <option [ngValue]="null" i18n>All</option>>
                                <option *ngFor="let assignment of assignments | localeSort: 'name'"
                                    [ngValue]="assignment.uuid">{{
                                    assignment.name }}</option>
                            </select>
                        </div>
                        <div class="col-12">
                            <label for="status" class="form-label" i18n>Status</label>
                            <select id="status" class="form-select" formControlName="status">
                                <option ngValue="all" i18n>All</option>
                                <option *ngFor="let status of adsPlacementStatuses | keyvalue" [ngValue]="status.key">{{
                                    status.value }}</option>
                            </select>
                        </div>
                        <div class="col-12">
                            <label for="text" class="form-label" i18n>Text search</label>
                            <input #searchText type="text" id="text" class="form-control" formControlName="text">
                        </div>
                        <div class="col-12">
                            <button (click)="search()" class="btn btn-primary" i18n>Search</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div class="col-9">
        <router-outlet></router-outlet>
    </div>
</div>